<template>
  <div rel="description">
    <div v-if="isEditing">
      <el-form-item label="段落说明">
        <wjQuillEditor :content="tempQuesData.title" :config="config" @onChange="handleEditorChange"></wjQuillEditor>
      </el-form-item>
    </div>
    <div v-else>
      <p class="ques-title" v-html="ques.title"></p>
    </div>
  </div>
</template>
<script>
  import wjQuillEditor from './wj-quill-editor.vue';
  export default {
    name: 'discription',
    props: ['tempQuesData', 'isEditing', 'ques', 'config'],
    components: {
      wjQuillEditor
    },
    methods: {
      handleEditorChange(data) {
        this.tempQuesData.title = data;
      },
    }
  }
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/description.vue